import { MESSAGES } from './types';
import { buildApiUrl } from '@/utils/url/build-url';
import { getConfig } from '@/utils/config/config';

const getLauncherOrigin = (): string => {
    const launcherUrl = buildApiUrl(getConfig().apis.LauncherClient);
    return new URL(launcherUrl).origin;
};

const sendMessageToGameWindows = (gameWindows: Window[], data: { type: string; payload?: any }) => {
    const launcherOrigin = getLauncherOrigin();
    gameWindows.forEach((gameWindow) => {
        if (gameWindow) {
            gameWindow.postMessage(data, launcherOrigin);
        }
    });
};

export const sendRealityCheckMessageToGameWindows = (gameWindows: Window[]) => {
    sendMessageToGameWindows(gameWindows, { type: MESSAGES.CLOSE_REALITY_CHECK_MODAL });
};
